import React from 'react';
import { Redirect } from 'react-router';
import { isBusinessManager } from 'services/permissions';

// This is the only way to redirect after login
// See https://stackoverflow.com/a/54422778
const InitialRedirect = () => {
  console.log('InitialRedirect: Component rendering');

  const businessManager = isBusinessManager();
  const ownConsultantSkillSet = localStorage.getItem('ownConsultantSkillSet');

  console.log('InitialRedirect: Retrieved values', {
    businessManager,
    ownConsultantSkillSet,
  });

  if (businessManager === null) {
    console.log('InitialRedirect: businessManager is null, waiting for auth data');
    return null;
  }

  if (businessManager) {
    console.log('InitialRedirect: User is business manager, redirecting to /consultantskillsets');
    return <Redirect to="/consultantskillsets" />;
  } else {
    if (!ownConsultantSkillSet || ownConsultantSkillSet === 'null') {
      console.warn('InitialRedirect: ownConsultantSkillSet is missing or null', {
        ownConsultantSkillSet,
        allLocalStorageKeys: Object.keys(localStorage),
        tokenExists: !!localStorage.getItem('token'),
      });
    }

    console.log(
      'InitialRedirect: User is not business manager, redirecting to consultant skill set:',
      ownConsultantSkillSet,
    );
    return <Redirect to={`/consultantskillsets/${ownConsultantSkillSet}`} />;
  }
};

export default InitialRedirect;
